import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWizardHat: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWizardHat"><Path d="M2.75 20.25L21.25 20.25" stroke="currentColor" strokeLinecap="square"/><Path d="M4.5 20L12 2.5L18.2143 8.41667H14.2786L19.5 20" stroke="currentColor" strokeLinecap="square"/><Path d="M10.1 11L10.45 11.75L11.2 12.1L10.45 12.45L10.1 13.2L9.74998 12.45L9 12.1L9.74998 11.75L10.1 11Z" stroke="currentColor"/><Path d="M13.3998 15L13.7498 15.75L14.4998 16.1L13.7498 16.45L13.3998 17.2L13.0498 16.45L12.2998 16.1L13.0498 15.75L13.3998 15Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconWizardHat;
